import { render, staticRenderFns } from "./DbpyD_Details.vue?vue&type=template&id=7a1bfa19"
import script from "./DbpyD_Details.vue?vue&type=script&lang=js"
export * from "./DbpyD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports